module.exports = __webpack_public_path__ + "static/screen-testing-279aed6f93978f489e896e5832a3679e.png";